import { clsx } from 'clsx';
import type { TextLinkProps } from './text-link';
import styles from './text-link.module.scss';

export function buildTextLinkClassName({ className, fullWidth, underline = 'always' }: Pick<TextLinkProps, 'className' | 'fullWidth' | 'underline'>) {
  return clsx(styles.textLink, fullWidth && styles.isFullWidth, styles[`underline-${underline}`], className);
}
